export default __webpack_public_path__ + "static/media/location.e2e7c14b.svg";